import { render } from "./ScanDetails.vue?vue&type=template&id=25445e7b"
import script from "./ScanDetails.vue?vue&type=script&lang=js"
export * from "./ScanDetails.vue?vue&type=script&lang=js"
script.render = render

export default script